import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10 4a2 2 0 0 0-2 2v1h14V6a2 2 0 0 0-2-2H10zM8 9v4c0 .434.142.832.377 1.16l4.533-2.824a2 2 0 0 1 2.635.465l.728.933a3.46 3.46 0 0 1 .72 2.266H20a2 2 0 0 0 2-2V9H8zm-3.252.092a1.19 1.19 0 0 0-.63.215l-2.259 1.57A1.996 1.996 0 0 0 1 12.517V19a2 2 0 0 0 2 2h5.582a3.35 3.35 0 0 0 2.787-1.492l3.361-3.783a1.461 1.461 0 0 0-.033-1.758c-.445-.677-1.01-.79-1.697-.33l-4.396 2.74C7.47 17.084 6 16.267 6 14.932V10.29a1.2 1.2 0 0 0-1.252-1.2z" }, null, -1)
  ])))
}
export default { render: render }